import React, {Component} from 'react';

const AbtaBox = props => (

  <div className="full-width-block mg-b">
    <div className="row no-padding wrap">
      <div className="column">
        <div className="image-container height-300-mob">
          <img src="/assets/img/abta-safehands.jpg" className="image radius full-width mg-v" alt="Abta image" title="Abta image" />
          <div className="absolute mg-t left pd-md">
            <h4 className={props.siteId == 1 ? 'white monty hide-for-large' : 'secondary monty hide-for-large'}>Why book with us?</h4>
            {props.siteId == 1 ?
              <h4 className='white monty show-for-large'>You're in safe hands</h4>
            :
              <h4 className='secondary monty show-for-large'>We're an ABTA member</h4>
            }
            <span className="hide-for-large white">
            {props.siteId == 1 ?
              <ul className="list tick no-mg">
                <li><span className='icon icon-tick white left'></span><p className='white'>Price match guarantee</p></li>
                <li><span className='icon icon-tick white left'></span><p className='white'>Finalise group size later</p></li>
                <li><span className='icon icon-tick white left'></span><p className='white'>0% interest <a className={props.siteId == 1 ? 'link white underline' : 'link black underline'} href="/part-payments">payment plans</a></p></li>
                <li><span className='icon icon-tick white left'></span><p className='white'>&pound;4.95pp amendment <a className={props.siteId == 1 ? 'link white underline' : 'link black underline'} href="/part-payments">flexibility</a></p></li>
                <li><span className='icon icon-tick white left'></span><p className='white'>Rated ‘Excellent’ on <a className={props.siteId == 1 ? 'link white underline' : 'link black underline'} href="https://uk.trustpilot.com/review/thestagcompany.com">Trustpilot</a></p></li>
              </ul>
            :
              <ul className="list tick no-mg">
                <li><span className='icon icon-tick secondary left'></span><p className='black'>&pound;1 deposit to book</p></li>
                <li><span className='icon icon-tick secondary left'></span><p className='black'>Unrivalled deals</p></li>
                <li><span className='icon icon-tick secondary left'></span><p className='black'>Flexible payments</p></li>
                <li><span className='icon icon-tick secondary left'></span><p className='black'>&pound;4.95pp <a className={props.siteId == 1 ? 'link white underline' : 'link black underline'} href="/part-payments">amendment flexibility</a></p></li>
                <li><span className='icon icon-tick secondary left'></span><p className='black'>Accommodation experts</p></li>
              </ul>
            }
            </span>
            <p className="mg-b max-70">
              {props.siteId == 1 ?
                <span className='show-for-large white'>We're a member of ABTA, so you can feel assured that your hard-earned money is in safe hands!*</span>
              :
                <span className='show-for-large black'>You're in safe hands when you book with us and package bookings are financially protected!</span>
              }
            </p>
            <img src="/global/img/abta-logo-safehands.png" alt="abta logo"/>
          </div>
        </div>
      </div>
    </div>
  </div>
);
export default AbtaBox
